
import HuobiToken from "../../../assets/filled/HuobiToken.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HuobiTokenIcon({ className, dataTestid = "HuobiTokenIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HuobiToken data-testid={dataTestid} className={classes} {...rest} />
  );
}
